import centralAPI from "../CentralAPIHandler/CentralAPIHandler";
import { getParams } from "./getParams";

const params = getParams()?.params;

export const captureMetrics = async ({dealerVinId=null, analyticsData=null, apiCallFlag=null, sessionId=null, timeSpent=0, engagement=null, teamId=null, totalViewDuration=null, activeViewDuration=null, unLoadFlag=false, zoomFeatureUsed=null, fullScreenDone=false, scriptTime=null, vinFetchTime=null, xpathForDivTime=null}) => {
    //POST API call to store the metrics
    let mediaId = params?.mediaId;
    const url = `${process.env.REACT_APP_MEDIA_BUCKET_URL_V3}/m/o/${mediaId}/inputConfigs.json`
    async function getInputConfigs() {
        try {
            const response = await fetch(url);
            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Error fetching input configs:', error);
        }
    }
    const inputConfigs = await getInputConfigs();
    const payload = {
        mediaId: params?.mediaId,
        skuName: params?.skuName || inputConfigs?.vinName,
        enterpriseId: params?.enterpriseId || inputConfigs?.enterpriseId,
        dealerVinId,
        version: params?.mediaId ? "v2" : null,
        teamId: teamId || inputConfigs?.teamId,
        sessionId: sessionId
    };

    if (!analyticsData) {
        payload.website_url = window.location.href;
    }

    if (totalViewDuration) {
        payload.totalViewDuration = totalViewDuration;
    }

    if (activeViewDuration) {
        payload.activeViewDuration = activeViewDuration;
    }

    if (apiCallFlag){
        payload.actionBy = apiCallFlag;
    }

    if (analyticsData) {
        payload.analytics = analyticsData;
    }

    if (timeSpent) {
        payload.timeSpent = timeSpent;
    }

    if (engagement) {
        payload.engagement = engagement;
    }

    if (zoomFeatureUsed && zoomFeatureUsed.length > 0) {
        payload.zoomFeatureUsed = zoomFeatureUsed;
    }
    
    if (fullScreenDone) {
        payload.fullScreenDone = fullScreenDone;
    }

    if (scriptTime) {
        payload.scriptTime = scriptTime;
    }

    if (vinFetchTime) {
        payload.vinFetchTime = vinFetchTime;
    }

    if (xpathForDivTime) {
        payload.xpathForDivTime = xpathForDivTime;
    }

    // console.log(payload, "called capture metrics with payloaddd")
    
    // For unload events, use fetch with keepalive
    if(!payload?.teamId && !payload?.skuName && !payload?.enterpriseId) {
        console.warn("capture metrics not called because teamId, skuName, enterpriseId are not present")
        return;
    }
    if (unLoadFlag) {
        fetch(`${process.env.REACT_APP_BASEURL_API_SPYNE}/spin/create-iframe-event`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
            keepalive: true
        }).catch(err => {
            console.log(err, "error in capture metrics")
        });
        return;
    }
    
    // Regular API call for non-unload events
    try {
        centralAPI.handlePostRequest(
            `${process.env.REACT_APP_BASEURL_API_SPYNE}/spin/create-iframe-event`,
            payload
        );
    } catch (analyticsError) {
        console.error('Failed to send analytics:', analyticsError);
    }
}